module.exports = __webpack_public_path__ + "static/Terry Shen.842be6fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Terry Shen.jpg
// module id = 1240
// module chunks = 6166952557895